<template>
  <div id="contenedor-listado-anticipos-contrato-mobile">
    <template v-for="(anticipo, index) in listadoAnticipos">
      <v-card :key="index" class="mb-3">
        <v-card-title class="secondary--text font-weight-bold">
          {{ new Date(`${anticipo.fecha} 00:00:0`).toLocaleDateString() }}
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <div>
              <span class="secondary--text font-weight-bold" cols="12">
                Porcentaje de anticipo:
              </span>
            </div>
            <div>
              <span>
                {{`${anticipo.porcentaje} %`}}
              </span>
            </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div>
              <span class="secondary--text font-weight-bold" cols="12">
                Importe de anticipo:
              </span>
            </div>
            <div>
              <span>
                {{anticipo.importe | currency }}
              </span>
            </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div>
              <span class="secondary--text font-weight-bold" cols="12">
                Porcentaje IVA:
              </span>
            </div>
            <div>
              <span>
                {{`${anticipo.porcentajeIva} %`}}
              </span>
            </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div>
              <span class="secondary--text font-weight-bold" cols="12">
                Importe IVA:
              </span>
            </div>
            <div>
              <span>
                {{anticipo.iva | currency }}
              </span>
            </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div>
              <span class="secondary--text font-weight-bold" cols="12">
                Importe Total:
              </span>
            </div>
            <div>
              <span>
                {{anticipo.total | currency }}
              </span>
            </div>
            </v-col>
          </v-row>
          <v-row justify="center">
              <v-btn icon x-large class="mx-4" @click="borrar(anticipo)">
                <v-icon> mdi-delete </v-icon>
              </v-btn>
              <v-btn icon x-large class="mx-4" @click="editar(anticipo)">
                <v-icon> mdi-pencil </v-icon>
              </v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ListadoAnticiposContratoMobile',
  props: {
    listadoAnticipos: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    editar(anticipoContrato) {
      eventBus.$emit('editar-anticipo-contrato', anticipoContrato);
    },
    borrar(anticipoContrato) {
      eventBus.$emit('eliminar-anticipo-contrato', anticipoContrato);
    },
  },
};
</script>

<style lang="scss">
</style>
